<app-attention-modal type="warning" title="Attention!" [messageTemplate]="message" [buttonsTemplate]="buttons"></app-attention-modal>

<ng-template #message>
  <div class="rkt-form mb-4">
    <div class="rkt-form-control">
      <div class="rkt-form-field">
        <label class="rkt-form-label" for="ba-state-select">New State</label>
        <div class="rkt-form-select-field">
          <ng-select
            inputId="ba-state-select"
            class="rkt-form-select"
            [items]="items"
            [(ngModel)]="selectedState"
            bindLabel="label"
            bindValue="value"
            placeholder="Select a state"
            [clearable]="false"
            [multiple]="false"
            [searchable]="false"
            [closeOnSelect]="true"
            appendTo="body"
          ></ng-select>
        </div>
      </div>
    </div>
  </div>

  <div>{{ warningText }}</div>
</ng-template>

<ng-template #buttons>
  <button type="button" rktButton btnType="tertiary" title="Cancel" (click)="activeModal.close()">Cancel</button>
  <button type="button" rktButton title="Confirm" [disabled]="!selectedState" (click)="activeModal.close(selectedState)">Confirm</button>
</ng-template>
